export const BYD_CLEAN_INSTANCE_KEY = 'VALUES-TO-DELETE';
